<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Осол саадын тоо" />
    <div class="content-body pd-0-f">
      <div class="container pd-0-f">
        <accident bd="bd-0"></accident>
      </div>
    </div>
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";
const moment = require("moment");
export default {
  components: {
    apexchart: VueApexCharts,
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    accident: () => ({
      component: import("@/views/apps/penalty/components/accident.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
}
</script>

<style>
</style>